import { FC, ReactElement } from 'react';

import { Link } from 'react-router-dom';

import { Logo, Wrapper } from '../../../../components';
import { ConnectedCartSideBar, ConnectedSearchDrawer } from '../../../../connectors';
import { Customer } from '../../../../entities/@account/Customer/Customer';
import { Navigation } from '../../../../entities/@navigation/Navigation/Navigation';
import { AppRoute, appRoutes } from '../../../../entities/Routing/Routing';
import { useTrans } from '../../../../hooks';
import { excludeMainNavigation, retrieveMainNavigationItem } from '../../helpers';
import { AccountControls, DesktopMainNavigation, DesktopSubNavigation } from '..';

import './DesktopMenu.scss';

interface DesktopMenuProps {
    isAuthenticated: boolean;
    wishlistIsLoading: boolean;
    wishlistItemsCount: number;
    navigation?: Navigation;
    customer?: Customer;
    className?: string;
}

export const DesktopMenu: FC<DesktopMenuProps> = ({
    isAuthenticated,
    wishlistIsLoading,
    wishlistItemsCount,
    navigation,
    customer,
    className = '',
}): ReactElement => {
    const trans = useTrans();

    const mainNavigationItem = retrieveMainNavigationItem(navigation);

    const mainNavigationLabel = mainNavigationItem?.label;
    const mainNavigation = mainNavigationItem?.subNavigation;

    const subNavigation = excludeMainNavigation(navigation);

    return (
        <div className={`desktop-menu ${className}`}>
            <Wrapper className="desktop-menu__wrapper">
                <div className="desktop-menu__navigation-wrapper">
                    <DesktopMainNavigation
                        label={mainNavigationLabel}
                        navigation={mainNavigation}
                        className="desktop-menu__main-navigation"
                    />

                    {subNavigation && (
                        <DesktopSubNavigation
                            subNavigation={subNavigation}
                            className="desktop-menu__sub-navigation"
                        />
                    )}
                </div>

                <Link
                    title={trans('containers.menu.homeLink')}
                    to={trans(appRoutes[AppRoute.home].path)}
                >
                    <Logo className="desktop-menu__logo" />
                </Link>

                <div className="desktop-menu__controls">
                    <ConnectedSearchDrawer />

                    <AccountControls
                        isAuthenticated={isAuthenticated}
                        wishlistIsLoading={wishlistIsLoading}
                        wishlistItemsCount={wishlistItemsCount}
                        customer={customer}
                    />

                    <ConnectedCartSideBar />
                </div>
            </Wrapper>
        </div>
    );
};
